import healthbookRouterMap from '@/router/modules/healthbook'

const manualRouterMap = [
  {
    name: "母子健康手册",
    path: "/manual/home",
    component: () => import("@/pages/manual/home"),
    meta: {
      systemCode: 'healthbook',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "母子健康手册",
    path: "/manual/healthBook",
    component: () => import("@/pages/manual/healthBook"),
    meta: {
      systemCode: 'healthbookhome',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "母子健康手册",
    path: "/manual/healthBookV2",
    component: () => import("@/pages/manual/healthBookV2"),
    meta: {
      systemCode: 'healthbookhomeV2',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "母子健康手册",
    path: "/manual/healthBookV3",
    component: () => import("@/pages/manual/healthBookV3"),
    meta: {
      systemCode: 'healthbookhomeV3',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "母子健康手册登录",
    path: "/manual/login",
    component: () => import("@/pages/manual/login")
  },
  {
    name: "母子健康手册备孕",
    path: "/manual/pregnant",
    component: () => import("@/pages/manual/pregnant")
  },
  {
    name: "文章详情",
    path: "/manual/detail",
    component: () => import("@/pages/manual/detail")
  },
  {
    name: "量表查询",
    path: "/manual/doctor/search",
    component: () => import("@/pages/manual/doctor/search")
  },
  {
    name: "查询结果",
    path: "/manual/doctor/list",
    component: () => import("@/pages/manual/doctor/list")
  },
  // 营养门诊高危筛查表
  {
    name: "营养门诊高危筛查表同意",
    path: "/nutritionscreening/agree",
    component: () => import("@/pages/nutritionscreening/agree")
  },
  {
    name: "基本信息",
    path: "/nutritionscreening/setinfostep1",
    component: () => import("@/pages/nutritionscreening/setinfostep1")
  },
  {
    name: "病史信息",
    path: "/nutritionscreening/setinfostep2",
    component: () => import("@/pages/nutritionscreening/setinfostep2")
  },
  {
    name: "膳食运动",
    path: "/nutritionscreening/setinfostep3",
    component: () => import("@/pages/nutritionscreening/setinfostep3")
  },
  {
    name: "孕史信息",
    path: "/nutritionscreening/setinfostep4",
    component: () => import("@/pages/nutritionscreening/setinfostep4")
  },
  {
    name: "营养门诊高危筛查表",
    path: "/nutritionscreening/detail",
    component: () => import("@/pages/nutritionscreening/detail")
  },
  {
    name: "完成",
    path: "/nutritionscreening/success",
    component: () => import("@/pages/nutritionscreening/success")
  },
  // 24小时膳食记录表
  {
    name: "24小时膳食记录表",
    path: "/mealrecord/guide",
    component: () => import("@/pages/mealrecord/guide")
  },
  {
    name: "基本信息",
    path: "/mealrecord/setinfostep1",
    component: () => import("@/pages/mealrecord/setinfostep1")
  },
  {
    name: "早上",
    path: "/mealrecord/setinfostep2",
    component: () => import("@/pages/mealrecord/setinfostep2")
  },
  {
    name: "下午",
    path: "/mealrecord/setinfostep3",
    component: () => import("@/pages/mealrecord/setinfostep3")
  },
  {
    name: "晚上",
    path: "/mealrecord/setinfostep4",
    component: () => import("@/pages/mealrecord/setinfostep4")
  },
  {
    name: "24小时膳食记录表",
    path: "/mealrecord/detail",
    component: () => import("@/pages/mealrecord/detail")
  },
  {
    name: "完成",
    path: "/mealrecord/success",
    component: () => import("@/pages/mealrecord/success")
  },
  {
    name: "历史记录",
    path: "/mealrecord/record",
    component: () => import("@/pages/mealrecord/record"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  //妊娠期糖尿病调查表
  {
    name: "妊娠期糖尿病调查表",
    path: "/diabetes/agree",
    component: () => import("@/pages/diabetes/agree")
  },
  {
    name: "基本信息",
    path: "/diabetes/setinfostep1",
    component: () => import("@/pages/diabetes/setinfostep1")
  },
  {
    name: "生育史及妊娠情况",
    path: "/diabetes/setinfostep2",
    component: () => import("@/pages/diabetes/setinfostep2")
  },
  {
    name: "生活习惯",
    path: "/diabetes/setinfostep3",
    component: () => import("@/pages/diabetes/setinfostep3")
  },
  {
    name: "妊娠期糖尿病调查表",
    path: "/diabetes/detail",
    component: () => import("@/pages/diabetes/detail")
  },
  {
    name: "完成",
    path: "/diabetes/success",
    component: () => import("@/pages/diabetes/success")
  }
];
export default manualRouterMap;
